module.exports = __webpack_public_path__ + "static/media/inlineImage123px.715e9f6a.svg";